import { AddNewAuthorCss } from "../css/Main.style";
import { ReactComponent as MainNewAuthor } from 'src/assets/main_newAuthor.svg';
import { ReactComponent as MainNewTitle } from 'src/assets/main_newTitle.svg';
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Alert from "../../layouts/modal/Alert";
import { useIsMobile } from "../../../hooks/useIsMobile";



const AddNewAuthor = () => {
    const navigate = useNavigate();

    const [showAlert, setShowAlert] = useState<false | "login" | "already" | "waiting" | "deactivated">(false);

    const [authorStatus, setAuthorStatus] = useState<string | null>(null);

    const handleClick = () => {
        const currentStatus = localStorage.getItem("authorStatus");
        if (!currentStatus || currentStatus === "null" || currentStatus === "undefined") {
            setShowAlert("login");
        } else {
            const status = currentStatus.toLowerCase();
            if (status === "author" || status === "active") {
                setShowAlert("already");
            } else if (status === "hold") {
                setShowAlert("deactivated");
            } else if (status === "pending" || status === "w") {
                setShowAlert("waiting");
            } else {
                navigate("/addAuthor");
            }
        }
    };

    const isMobile = useIsMobile();

    return (


        <>

            {isMobile ?
                <div css={AddNewAuthorCss}>
                    <div className="flex flex-row justify-center items-center w-full min-w-0 gap-4">
                        <div className="w-[100px] min-w-[100px] floating-char">
                            <MainNewAuthor className="w-full h-full object-contain drop-shadow-md" />
                        </div>

                        <div className={"flex flex-col items-center gap-4"}>
                            <div className="flex flex-col items-center text-left gap-1.5 whitespace-nowrap">
                                <span className={"text-[22px] text-black font-Hakgyoansim leading-tight"}>내 작품, 더 알릴 수는 없을까?</span>
                                <div className="flex flex-col items-center gap-0.5 mt-1">
                                    <p className="text-gray-800 text-[12px] font-medium m-0 opacity-90">마음 속에 남아있는 작품 이야기를 꺼내</p>
                                    <p className="text-gray-800 text-[12px] font-medium m-0 opacity-90">독자와 이어질 새로운 활동을 시작해 보세요!</p>
                                </div>
                            </div>

                            <div className="flex items-center justify-center mt-1">
                                <button onClick={handleClick}
                                    className="w-[160px] h-[44px] bg-white rounded-full border-[#19CF7A] border-2 shadow-sm active:scale-95 transition-transform">
                                    <span className="text-main text-[15px] font-bold leading-none">작가 등록하기</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    {showAlert && (
                        <Alert
                            title="알림"
                            message={
                                showAlert === "login"
                                    ? "로그인이 필요합니다."
                                    : showAlert === "already"
                                    ? "이미 작가로 등록되어있어요!\n작가님의 다양한 작품 활동 소식을 많이 알려주세요 :)"
                                    : showAlert === "deactivated"
                                    ? "이미 작가로 등록되어있습니다."
                                    : "이미 작가 등록 신청을 해주셨어요!\n운영진이 꼼꼼하게 검토하고 빠르게 안내해 드릴게요."
                            }
                            onClose={() => setShowAlert(false)}
                        />
                    )}
                </div>


                :
                <div css={AddNewAuthorCss}>
                    <div className="flex flex-row gap-12 items-center justify-center max-w-[1200px] w-full px-10">
                        <div className="floating-char">
                            <MainNewAuthor className={"w-[240px] h-auto drop-shadow-xl"} />
                        </div>

                        <div className={"flex flex-col items-center gap-8"}>
                            <div className="flex flex-col items-center text-left gap-4">
                                <h2 className={"text-[clamp(32px,4vw,64px)] text-black font-Hakgyoansim leading-[1.1] tracking-tight whitespace-normal md:whitespace-nowrap"}>
                                    내 작품, 더 알릴 수는 없을까?
                                </h2>
                                <div className="flex flex-col items-center gap-1.5 opacity-90">
                                    <p className="text-[#333] text-[clamp(18px,1.5vw,26px)] font-medium m-0">마음 속에 남아있는 작품 이야기를 꺼내</p>
                                    <p className="text-[#333] text-[clamp(18px,1.5vw,26px)] font-medium m-0">독자와 이어질 새로운 활동을 시작해 보세요!</p>
                                </div>
                            </div>

                            <div className="mt-2">
                                <button onClick={handleClick}
                                    className="premium-button w-[320px] h-[66px] bg-white rounded-full border-[#19CF7A] border-[2px] shadow-lg flex items-center justify-center">
                                    <span className="text-main text-[26px] font-bold">작가 등록하기</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    {showAlert && (
                        <Alert
                            title="알림"
                            message={
                                showAlert === "login"
                                    ? "로그인이 필요합니다."
                                    : showAlert === "already"
                                    ? "이미 작가로 등록되어있어요!\n작가님의 다양한 작품 활동 소식을 많이 알려주세요 :)"
                                    : showAlert === "deactivated"
                                    ? "이미 작가로 등록되어있습니다."
                                    : "이미 작가 등록 신청을 해주셨어요!\n운영진이 꼼꼼하게 검토하고 빠르게 안내해 드릴게요."
                            }
                            onClose={() => setShowAlert(false)}
                        />
                    )}


                </div>

            }
        </>


    )


}

export default AddNewAuthor
